import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { EmptyState } from '../components/EmptyState';
import { Button } from '../components/ui/button';
import usePageTitle from '../hooks/usePageTitle';

/** Rendered for unknown paths inside the authenticated shell — no silent redirects. */
const NotFound: React.FC = () => {
  usePageTitle('Page not found');

  return (
    <EmptyState
      titleAs="h1"
      icon={Compass}
      title="Page not found"
      description="The address may be mistyped, or the page may have moved."
      action={
        <Button asChild>
          <Link to="/my-apps">Go to App Clients</Link>
        </Button>
      }
      className="py-20"
    />
  );
};

export default NotFound;
